import { Button, Icon, Tooltip, TooltipContent, TooltipTrigger } from "@qw/ui";
import { Link, type To } from "react-router";

// Narrows the mail list and the search box to this insured's linked email. The
// scope is the route rather than a query param — `useClearScopeTarget` in
// `app/search-scope-chips.tsx` derives the chip from `:insuredId` in the path — so this
// is a `Link`, not a write.
export const ViewLinkedEmailButton = ({ to }: { to: To }) => (
  <Tooltip>
    <TooltipTrigger asChild>
      <Button asChild variant="outline" size="sm" display="icon">
        <Link to={to} aria-label="View all linked email">
          <Icon icon="stacked_email" />
        </Link>
      </Button>
    </TooltipTrigger>
    <TooltipContent>View all linked email</TooltipContent>
  </Tooltip>
);
